import React ,{useEffect} from 'react';
import "./App.css";
import "./assets/css/atlantis.css";
import "./assets/js/atlantis.js";
import "./assets/css/Common.css";
import "../src/assets/css/bootstrap.min.css";
import "./assets/css/fonts.css";
import "jquery";
import WithNav from "./Components/SideBar/WithNav";
import WithoutNav from "./Components/SideBar/WithoutNav";
import Login from "./Components/Login/Login";
import EmployeeList from "./Components/Employee/EmployeeList";
import RoleIndex from "./Components/Role/RoleIndex";
import EmailTemplateCreate from "./Components/EmailTemplate/EmailTemplateCreate";
import ApplicationIndex from "./Components/ApplicationConfig/ApplicationConfigIndex";
import { Username } from "./Components/Login/Username";
import { OTP } from "./Components/Login/OTP";
import { Forgotpassword } from "./Components/Login/Forgotpassword";
import { ChangePassword } from "./Components/Login/ChangePassword";
import { LogoutHR } from "./Components/SideBar/LogoutHR";
import Associate from "./Components/Associate/MainGrid";
import FundRequestList from "./Components/FundRequest/FundRequestList";
import { RoleConfig } from "./Components/RoleConfig/RoleConfig";
import Emailtemplate from "./Components/EmailTemplate/Emailtemplate";
import { Cybertronic } from "./Components/Login/Cybertronic";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginTracker from "./Components/ApplicationConfig/LoginTracker";
import StudentMain from "./Components/Student/StudentMain";
import StudentList from "./Components/Student/StudentList";
import StudentEditList from "./Components/Student/StudentProfileApprovelist";
import ApprovalGrid from "./Components/FundApproval/ApprovalGrid";
import Index from "./Components/Dashboard/Index";
import FundReport from "./Components/ApplicationConfig/Fund_Report";
import CreditReport from "./Components/ApplicationConfig/CreditReport";
import AdvanceBillList from "./Components/FundApproval/AdvanceBillList";
import StudentBankDetails from "./Components/Student/StudentBankDetails";
import StudentView from "./Components/Student/SemesterResult";


function App() {
  useEffect(() => {
    const hostname = window.location.hostname;
    if (window.location.protocol === 'http:' && !/(qa|uat|localhost)/.test(hostname)) {
      window.location.href = window.location.href.replace('http:', 'https:');
    }
  }, []);
  if (window.location.protocol === 'http:' && !/(qa|uat|localhost)/.test(window.location.hostname)) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}>
        Loading...
      </div>
    );
  }
  
   return (
    <Router>
      <Routes>
        <Route element={<WithoutNav />}>
          <Route path="/" exact index element={<Login />} />
          <Route path="/Username" exact index element={<Username />} />
          <Route path="/OTP" exact index element={<OTP />} />
          <Route
            path="/Forgotpassword"
            exact
            index
            element={<Forgotpassword />}
          />
          <Route path="/Cybertronic" exact index element={<Cybertronic />} />
          <Route path="/LogoutHR" exact index element={<LogoutHR />} />

          {/* <Route path="/test" exact index element={<Test />} /> */}
        </Route>

        <Route element={<WithNav />}>
          {/* <Route path="/Login" exact index element={<Login />} /> */}
          <Route path="/RoleIndex" exact index element={<RoleIndex />} />
          <Route
            path="/ApplicationIndex"
            exact
            index
            element={<ApplicationIndex />}
          />
          <Route path="/Employee" exact index element={<EmployeeList />} />
          <Route
            path="/StudentProfileApprovelist"
            exact
            index
            element={<StudentEditList />}
          />
          <Route
            path="/FundRequest"
            exact
            index
            element={<FundRequestList />}
          />
          <Route
            path="/ChangePassword"
            exact
            index
            element={<ChangePassword />}
          />
          <Route path="/Associate" element={<Associate />} />
          <Route path="/Role" element={<RoleConfig />} />
          <Route path="/StudentMain" element={<StudentMain />} />

          <Route path="/StudentList" element={<StudentList />} />
          <Route path="/ApprovalGrid" element={<ApprovalGrid />} />
          <Route path="/ApprovalBillGrid" element={<AdvanceBillList />} />
          <Route path="/Emailtemplate" element={<Emailtemplate />} />
          <Route
            path="/EmailTemplateCreate"
            element={<EmailTemplateCreate />}
          />
          <Route path="/LoginTracker" element={<LoginTracker />} />
          <Route path="/Index" element={<Index />} />
          <Route path="/FundReport" element={<FundReport />} />

          <Route path="/CreditReport" element={<CreditReport />} />
          <Route path="/StudentBankDetails" element={<StudentBankDetails />} />
          <Route path="/StudentView" element={<StudentView />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
